// extracted by css-extract-rspack-plugin
var _1 = "fE1etbiFbk0L8JWYsoUNEw--";
var _2 = "ZpE72wrjUqxHjjXhzHIYzA--";
var _3 = "_2bpEpAI0I4MiKEQXhcMbHw--";
var _4 = "_9PQexIEk32HlwbVuSA2shg--";
export { _1 as "container", _2 as "left", _3 as "receipt", _4 as "right" }
